export default __webpack_public_path__ + "static/media/aocaboteatro.75e1f30a.png";